import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/imagen_cotizaciones_alfapack.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block pb-4 pt-6" }
const _hoisted_3 = { class: "columns is-centered is-mobile" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Sabemos que al inicio de cualquier proyecto surgen muchas dudas e interrogantes. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pb-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Permítenos asesorarte y responder todas tus inquietudes. ", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("figure", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "has-ratio",
    src: _imports_0,
    alt: "imagen_cotizaciones_alfapack.jpg"
  })
], -1)
const _hoisted_8 = { class: "container pt-6 pb-6" }
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-justified is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Para nosotros, lo más importante es satisfacer tus necesidades. Nuestro equipo de atención al cliente se pondrá en contacto contigo para coordinar un seguimiento adecuado y proporcionarte la información y videos que necesitas sobre nuestros equipos. Nuestros ingenieros están disponibles para resolver todas tus dudas y planificar contigo una exitosa implementación de nuestros equipos. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary is-size-5 has-text-justified pt-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " MANOS A LA OBRA ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary is-size-6 has-text-justified",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Llena el formulario y un asesor se pondrá en contacto contigo. ", -1)
const _hoisted_13 = { class: "pt-5" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Nombre\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Apellido\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Empresa\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"E-mail\" type=\"email\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Teléfono\" type=\"phone\"></div></div>", 5)
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control" }
const _hoisted_21 = {
  class: "select",
  style: {"width":"100%"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  class: "has-text-gray",
  disabled: "",
  selected: "",
  value: ""
}, " Forma de contacto ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "whatsapp" }, "WhatsApp", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "email" }, "E-mail", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "llamada" }, "Llamada", -1)
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = {
  class: "select",
  style: {"width":"100%"}
}
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<option class=\"has-text-gray\" disabled selected value=\"\"> Estoy interesado en </option><option value=\"envasado_tabletas\"> Envasado de Tabletas </option><option value=\"equipos_pharma\">Equipos Pharma</option><option value=\"encartonadores_pallets\"> Encartonadores y Pallets </option><option value=\"codificadores\">Codificadores</option><option value=\"selladoras_bolsas\"> Selladoras de Bolsas </option><option value=\"inspeccion_rayos_x\"> Inspección por Rayos X </option><option value=\"extractores_humo\">Extractores de Humo</option><option value=\"servicio_refacciones\"> Servicio y Refacciones </option>", 9)
const _hoisted_39 = [
  _hoisted_30
]
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"País\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Estado\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><input class=\"input\" placeholder=\"Comentarios\" type=\"text\"></div></div><div class=\"field\"><div class=\"control\"><label class=\"checkbox\"><input type=\"checkbox\"> Acepto <a href=\"#\">Términos y condiciones</a> y <a href=\"#\">Aviso de privacidad</a></label></div></div>", 4)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button has-background-yellow has-text-white",
    style: {"width":"15rem"}
  }, " ENVIAR ")
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "block" }
const _hoisted_47 = { class: "columns pt-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("iframe", {
  height: "450",
  width: "100%",
  frameborder: "0",
  src: "https://www.google.com/maps/embed/v1/place?q=Mira+Cañada+10,+Cumbria,+Cuautitlán+Izcalli,+Estado+de+México,+México&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
}, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-left is-size-6 pt-2",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Disponibles de lunes a viernes, de 9:00 a.m. a 6:00 p.m. ", -1)
const _hoisted_51 = { class: "container" }
const _hoisted_52 = { class: "columns is-centered is-mobile pb-6" }
const _hoisted_53 = { class: "block pb-6" }
const _hoisted_54 = { class: "columns is-mobile" }
const _hoisted_55 = { class: "column" }
const _hoisted_56 = {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " ESTADO DE MÉXICO ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740 ", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671 ", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " contacto@alfapack.com.mx ", -1)
const _hoisted_61 = { class: "column" }
const _hoisted_62 = {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6 pt-4",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " MÉRIDA ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740 ", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671 ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered is-size-6",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " contacto@alfapack.com.mx ", -1)

import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { useWindowSize } from "vue-window-size";
import { ref } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMapMarker } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'CotizacionView',
  setup(__props) {

const { width } = useWindowSize();
let formaContacto = ref("");
let interes = ref("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ContactBar),
      _createVNode(NavigationBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " ESTAMOS LISTOS PARA HACER LA DIFERENCIA ", 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["column", _unref(width) < 768 ? 'is-four-fifths' : 'is-two-thirds'])
          }, _hoisted_6, 2)
        ])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["column", _unref(width) < 768 ? '' : 'is-two-fifths'])
        }, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-left has-text-primary pb-4", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " COMPÁRTENOS TUS DATOS ", 2),
          _hoisted_10
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["column", _unref(width) < 768 ? '' : 'is-three-fifths'])
        }, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("form", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formaContacto) ? (formaContacto).value = $event : formaContacto = $event)),
                    style: _normalizeStyle([{"width":"100%"}, _unref(formaContacto) == '' ? 'color: lightGray' : ''])
                  }, _hoisted_26, 4), [
                    [_vModelSelect, _unref(formaContacto)]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(interes) ? (interes).value = $event : interes = $event)),
                    style: _normalizeStyle([{"width":"100%"}, _unref(interes) == '' ? 'color: lightGray' : ''])
                  }, _hoisted_39, 4), [
                    [_vModelSelect, _unref(interes)]
                  ])
                ])
              ])
            ]),
            _hoisted_40,
            _createElementVNode("div", {
              class: _normalizeClass(["field is-grouped", _unref(width) < 768 ? 'is-grouped-centered' : ''])
            }, _hoisted_45, 2)
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", {
          class: _normalizeClass(["column map-column", _unref(width) < 768 ? '' : 'is-three-fifths'])
        }, _hoisted_49, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["column", _unref(width) < 768 ? '' : 'is-two-fifths']),
          style: {"background-color":"#f4f4f6","max-height":"450px"}
        }, [
          _createElementVNode("div", {
            class: "container",
            style: _normalizeStyle(_unref(width) < 768 ? '' : 'height: 100%; padding-top: 30%')
          }, [
            _createElementVNode("h1", {
              class: _normalizeClass(["has-text-left has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
              style: {"font-family":"Calibri","font-weight":"bold"}
            }, " NUESTROS HORARIOS ", 2),
            _hoisted_50
          ], 4)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", {
          class: _normalizeClass(["column", _unref(width) < 768 ? 'is-four-fifths' : 'is-two-thirds'])
        }, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE ", 2)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("p", _hoisted_56, [
              _createVNode(_unref(SvgIcon), {
                type: "mdi",
                class: "p-4",
                path: _unref(mdiMapMarker),
                style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
              }, null, 8, ["path"])
            ]),
            _hoisted_57,
            _hoisted_58,
            _hoisted_59,
            _hoisted_60
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("p", _hoisted_62, [
              _createVNode(_unref(SvgIcon), {
                type: "mdi",
                class: "p-4",
                path: _unref(mdiMapMarker),
                style: {"color":"white","background-color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
              }, null, 8, ["path"])
            ]),
            _hoisted_63,
            _hoisted_64,
            _hoisted_65,
            _hoisted_66
          ])
        ])
      ])
    ]),
    _createVNode(ContactMedia),
    _createVNode(FooterComponent)
  ], 64))
}
}

})